import {
    ACCOUNT,
    DATA_ACCESS,
    PLATFORM_OPTIONS,
    SECURITY,
    SUBSCRIPTION_INVOICES,
    THEMES,
    USERS_ROLES
} from '@/routes/privateRoutes';

export const pagesWithoutSubscription = [
    ACCOUNT,
    DATA_ACCESS,
    PLATFORM_OPTIONS,
    THEMES,
    SECURITY,
    SUBSCRIPTION_INVOICES,
    USERS_ROLES
];
